import React from "react";

export default function Footer(){
  return(
    <footer className="footerdd pt-10">
        <footer className="footer-div">
          <p className="foot-text">Designed and developed by Shreya Jash with ❤️</p>   
      </footer>
    </footer>
      

  )
}